/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * MALIYONE-LOAN-MANAGEMENT-API API
 * API specification for MALIYONE-LOAN-MANAGEMENT-API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Type of loan
 */
export type LeadLoanType = typeof LeadLoanType[keyof typeof LeadLoanType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LeadLoanType = {
  BUSINESS: 'BUSINESS',
  PERSONAL: 'PERSONAL',
} as const;
